import WhaleIntro from './WhaleIntro';
import WhaleIsland from './WhaleIsland';
import CharacteristicsGame from './CharacteristicsGame';
import WhaleOutro from './WhaleOutro';
import WhaleOutro2 from './WhaleOutro2';

export default [WhaleIsland, WhaleIntro, CharacteristicsGame, WhaleOutro, WhaleOutro2];
